import React from "react";
import styled from "styled-components";
import PortfolioList from "../../portfolio/PortfolioList";
import {shadedBackgroundColour} from "../../../../../style/styleConsts";
import {Benchmark, BenchmarkHeader} from "./Benchmark";
import {ClosedPortfolioNameCell, PorfolioNameHeader, PortfolioNameCell} from "./PortfolioName";
import {KpiCell, KpiHeader} from "./PortfolioKpi";
import {InvestmentCell, InvestmentHeader} from "./Investment";
import {DescriptionCell, DescriptionPadding} from "./Description";
import {PriceHeader, PricesCell} from "./StartPrice";

const PortfolioRow = styled.div`
    display: flex;
    align-items: stretch;
    height: 32px;
    flex-shrink: 0;
    padding-left: 6px;
    padding-right: 6px;
    border-bottom: 1px solid #d6d0c8;
`;


const sortPortfolios = (p1, p2) => {
    return p1.name.localeCompare(p2.name);
};

const ViewPortfolioList = ({portfolios, authorId, currentUserId}) => {

    const allPortfolios = portfolios.sort(sortPortfolios);

    const rowRenderer = (portfolio, style) => {
        if (!portfolio.open) {
            style.background = shadedBackgroundColour;
            style.borderTop = "1px solid #d6d0c8";
            return (
                <PortfolioRow key={portfolio.id} style={style}>
                    <ClosedPortfolioNameCell portfolioIdea={portfolio} authorId={authorId} currentUserId={currentUserId}/>
                    <DescriptionCell state={portfolio.state}/>
                </PortfolioRow>
            );
        } else {
            return (
                <PortfolioRow key={portfolio.id} style={style}>
                    <PortfolioNameCell portfolioIdea={portfolio} authorId={authorId} currentUserId={currentUserId}/>
                    <Benchmark portfolioIdea={portfolio}/>
                    <InvestmentCell portfolioIdea={portfolio}/>
                    <PricesCell className="t-price" portfolioIdea={portfolio}/>
                    <KpiCell portfolioIdea={portfolio}/>
                </PortfolioRow>
            );
        }
    };
    const headers = <>
        <PorfolioNameHeader key="portfolio-name-header"/>
        <BenchmarkHeader key="benchmark"/>
        <InvestmentHeader key="investment-amount-header"/>
        <PriceHeader key="price-header"/>
        <KpiHeader key="kpi-header"/>
    </>;
    return (
        <PortfolioList portfolioRenderer={rowRenderer}
                       portfolios={allPortfolios}
                       headerElements={headers}/>
    );
};

export default ViewPortfolioList;